import {useEffect, useState} from 'react'
import {firestore} from '../firebase/config' 

import { collection, onSnapshot, query, orderBy } from "firebase/firestore";

// listen for the real time updates, and get the data on every new update
const useRealFirestore = (collectionName) =>{
    
    const [docs, setDocs] = useState([])

    useEffect(() =>{        
        const ref = query(collection(firestore, collectionName), orderBy('createdAt'));
        const unsubscribe = onSnapshot(ref, (snap) => {
            let documents = [];
            snap.forEach((doc) => {
                documents.push({...doc.data(), id: doc.id});
            })
            setDocs(documents)
        });
        return () => unsubscribe()
    },[collectionName])

    return {docs}
}

export default useRealFirestore